import {ENUMS} from "../../../services/enums"
import dates from "../../../services/dates";

export let CommEmailModalMixin = {
  props: {
    contact: {
      type: Object,
      required: true
    },
    comms: {
      type: Array,
      required: true,
    },
    record: Object,
    availableRecords: {
      type: Array,
    }
  },
  data() {
    return {
      currentEmail: null,
      defaultData: {}
    }
  },
  created() {
    this.resetCurrentEmail();
  },
  computed: {
    emails() {
      const emails = this.comms.filter(comm => comm.type === ENUMS.CommunicationTypeEnum.Email.value);
      return emails.sort((a,b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
    },
  },
  methods: {
    convertDate(date) {
      return dates.formatAsDateTime(date);
    },
    setCurrentEmail(email) {
      if(email && email.id !== 'new') {
        this.currentEmail = email;
      } else {
        this.resetCurrentEmail();
      }
    },
    backToList() {
      this.resetCurrentEmail();
    },
    reply(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'reply');
    },
    replyAll(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'replyAll');
    },
    forward(email) {
      this.resetCurrentEmail();
      this.setDefaultData(email, 'forward');
    },
    resetCurrentEmail() {
      // This changes the UI to show Email list form with the above default data
      if(this.$store.state.isMobile) {
        this.currentEmail = {
          id: null
        }
      } else {
        this.currentEmail = {
          id: 'new'
        }
      }
      this.defaultData = null;
    },
    setDefaultData(email, type) {
      // available types = reply, replyAll, or forward (although forward isn't really used)
      // All types require name, date, to, subject, and body
      // ReplyAll requires cc and bcc as well
      const date = dates.formatAsDateTime(email.created_at);
      const prefix = type === 'reply' || 'replyAll' ? 'RE: ' : 'FW: ';

      let tos = [];
      let ccs = [];
      let bccs = [];

      if (type !== 'forward') {
        if (ENUMS.CommunicationDirectionEnum.Inbound.value === email.communication_direction) {
          tos = [email.email_from.email_address]
        } else {
          tos = email.email_to.map(to => to.email_address);
        }

        ccs = email.email_cc.map(cc => cc.email_address);
        bccs = email.email_bcc.map(bcc => bcc.email_address);
      }

      this.defaultData = {
        user_id: this.$store.getters.authUser.id,
        record_id: email.record_id,
        name: email.email_from.name,
        from: email.email_from.email_address,
        to: tos,
        cc: ccs,
        bcc: bccs,
        subject: prefix + email.email_subject,
        body: email.email_body,
        date: date
      }
    },
  }
}
